/* ----------------- Types --------------- */

import { useAilaStore } from "@features/session/hooks/useAilaStore";
import BottomFab from "@memorang/ui/src/components/BottomFab";
import Box from "@memorang/ui/src/components/Box";
import { CustomListSubheader } from "@memorang/ui/src/components/CustomListSubheader";
import ScrollContainer from "@memorang/ui/src/components/ScrollContainer";
import { useRouter } from "expo-router";
import { issues } from "../hooks/useArticles";
import type { Article, Issue } from "../types";
/* ----------------- Components --------------- */
import { SavedArticlesList } from "./SavedArticlesList";

interface Props {
	savedArticles: Article[];
	handleSelectArticle: (id: number) => void;
	handleNavigateToArticle: (id: number) => void;
	selectedArticleIds: number[];
}
const SavedArticlesView = ({
	savedArticles,
	handleSelectArticle,
	handleNavigateToArticle,
	selectedArticleIds,
}: Props) => {
	const router = useRouter();
	const updateUserPrompt = useAilaStore((state) => state.updateUserPrompt);
	const updateItemId = useAilaStore((state) => state.updateItemId);
	const updateIsItemAnswered = useAilaStore(
		(state) => state.updateIsItemAnswered,
	);
	const updateOriginalQuestionData = useAilaStore(
		(state) => state.updateOriginalQuestionData,
	);

	const handleNavigateToAssistant = () => {
		const finalSelectedArticleIds =
			selectedArticleIds.length === 0
				? savedArticles.map((article) => article.id)
				: selectedArticleIds;

		const sortedSelectedArticleIds = finalSelectedArticleIds.sort(
			(a, b) => Number(a) - Number(b),
		);
		const selectedArticles = issues
			.flatMap((issue: Issue) => issue.articles)
			.filter((article: Article) =>
				finalSelectedArticleIds.includes(article.id as never),
			);

		const userPrompt = selectedArticles.reduce(
			(acc: string, article: Article, index: number) => {
				return `${acc}\nArticle ${index + 1} title: ${article.title}\nArticle ${index + 1} type: ${article.type}`;
			},
			"",
		);

		updateUserPrompt(userPrompt);
		updateItemId(JSON.stringify(sortedSelectedArticleIds));
		updateIsItemAnswered(true);
		updateOriginalQuestionData(undefined);
		router.push({
			pathname: "/aila/[itemId]",
			params: {
				itemId: sortedSelectedArticleIds.join("_"),
			},
		});
	};

	return (
		<>
			<ScrollContainer>
				<Box>
					<CustomListSubheader>Saved Articles</CustomListSubheader>
					<SavedArticlesList
						savedArticles={savedArticles}
						handleSelectArticle={handleSelectArticle}
						handleNavigateToArticle={handleNavigateToArticle}
						selectedArticleIds={selectedArticleIds}
					/>
				</Box>
			</ScrollContainer>
			<BottomFab
				disabled={selectedArticleIds.length === 0}
				onPress={handleNavigateToAssistant}
				icon={"chat-question-outline"}
				label="First Assist"
				bottom={16}
			/>
		</>
	);
};

export default SavedArticlesView;
